import { cn } from '@commenda/utils';
import React from 'react';

export const SettingValue = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <span className={cn('txt-small-regular text-text-secondary', className)}>
    {children}
  </span>
);

type SettingIconButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: React.ReactNode;
  label: string;
};

export const SettingIconButton = React.forwardRef<
  HTMLButtonElement,
  SettingIconButtonProps
>(({ icon, label, className, ...buttonProps }, ref) => (
  <button
    ref={ref}
    type="button"
    aria-label={label}
    className={cn(
      'flex cursor-pointer items-center justify-center rounded-sm bg-transparent p-xs text-fg-secondary',
      'hover:bg-bg-secondary hover:text-fg-primary disabled:cursor-default disabled:text-fg-disabled disabled:hover:bg-transparent',
      className
    )}
    {...buttonProps}
  >
    {icon}
  </button>
));

SettingIconButton.displayName = 'SettingIconButton';

type SettingHeaderActionProps =
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    icon?: React.ReactNode;
  };

export const SettingHeaderAction = React.forwardRef<
  HTMLButtonElement,
  SettingHeaderActionProps
>(({ icon, children, className, ...buttonProps }, ref) => (
  <button
    ref={ref}
    type="button"
    className={cn(
      'flex shrink-0 cursor-pointer items-center gap-sm rounded-sm border-1/2 border-border-primary bg-bg-primary px-md py-sm',
      'hover:bg-bg-secondary disabled:cursor-default disabled:opacity-60',
      className
    )}
    {...buttonProps}
  >
    {icon}
    <span className="txt-small-medium text-text-tertiary">{children}</span>
  </button>
));

SettingHeaderAction.displayName = 'SettingHeaderAction';
